import { buildPluginsHeader } from "./registry";
import { getImpersonation, isImpersonating } from "./userMatrixStorage";

const AUTH_TOKEN_KEY = "projectBoardAuthToken";

/** Auth, plugin, and impersonation headers for API requests. */
export function buildAuthRequestHeaders(extra = {}) {
  const h = { ...buildPluginsHeader(), ...extra };
  try {
    const token = localStorage.getItem(AUTH_TOKEN_KEY);
    if (token) h.Authorization = `Bearer ${token}`;
    if (isImpersonating()) {
      const imp = getImpersonation();
      if (imp?.email) {
        h["X-PB-Impersonate-Email"] = String(imp.email).trim().toLowerCase();
      }
      if (imp?.userTypeId) {
        h["X-PB-Impersonate-User-Type-Id"] = String(imp.userTypeId).trim();
      }
    }
  } catch {
    /* ignore */
  }
  return h;
}
